import {
  getDebateWiningIcon,
  getOptionBgColor,
  getOptionColor,
  getWiningIcon,
} from "components/templates/common/Discuss/util";
import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { TYPO } from "styles/Typo";

function OptionBadge({ data }: { data: CommentItem }) {
  return (
    <div
      className={`w-fit px-1 py-[2px] flex items-center gap-[2px] ${getOptionBgColor(
        data?.user_vote_symbol
      )} rounded-[6px]`}
      data-test-id={`option-badge-${data?.comment_id}`}
    >
      <div>{getDebateWiningIcon(data?.user_vote_symbol)}</div>
      <span
        className={`${TYPO.TYPO10_MD} ${getOptionColor(
          data?.user_vote_symbol
        )}`}
      >
        {data?.user_vote_option}
      </span>
    </div>
  );
}

export default OptionBadge;
